export type StopwatchAvailabilityStatus =
  | "available"
  | "daily_limit_reached"
  | "weekly_limit_reached"
  | "both_limits_reached";

export interface StopwatchAvailabilityDTO {
  status: StopwatchAvailabilityStatus;
}

export const stopwatchAvailabilityMessage: Record<
  StopwatchAvailabilityStatus,
  string | null
> = {
  available: null,
  daily_limit_reached: "You have reached the maximum daily hours allowed.",
  weekly_limit_reached: "You have reached the maximum weekly hours allowed.",
  both_limits_reached: "You have reached the maximum allowed working hours.",
};
